export default {"src":"/_next/static/media/picnic.329cf69d.svg","height":100,"width":100,"blurWidth":0,"blurHeight":0};